import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=6c9d4ab4&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=6c9d4ab4&prod&scoped=true&lang=css"
import style1 from "./transfer.vue?vue&type=style&index=1&id=6c9d4ab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d4ab4",
  null
  
)

export default component.exports